import { render, staticRenderFns } from "./FormVisitComponent.vue?vue&type=template&id=08a56316"
import script from "./FormVisitComponent.vue?vue&type=script&lang=js"
export * from "./FormVisitComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports